type ChekinRuntimeSettings = {
  autoHeight?: boolean;
};

export function getChekinRuntimeSettings(): ChekinRuntimeSettings {
  return window.ChekinProSettings || window.ChekinHousingsSDKSettings || {};
}

export function isMobileModalModeAvailable() {
  const settings = getChekinRuntimeSettings();
  return !settings.autoHeight;
}
